import { Box, Button, Flex, Grid } from '@chakra-ui/react';
import { ethers } from 'ethers';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { FormSectionAddon } from 'src/components/common/texts/FormSectionAddon/formSectionAddon';
import { FormSectionHeading } from 'src/components/common/texts/FormSectionHeading/formSectionHeading';
import { Stages, useCartridgeCreatorProvider } from 'src/providers/Cartridge/cartridgeProvider';
import { LeftColumn } from '../../containers/TwoColumn/leftColumn';
import { RightColumn } from '../../containers/TwoColumn/rightColumn';
import { TwoColumn } from '../../containers/TwoColumn/twoColumn';
import { FinalizationButtons } from './FinalizationButtons/finalizationButtons';
import { FinalizationProgress } from './FinalizationProgress/finalizationProgress';

export const Finalization = () => {
	const { t } = useTranslation();
	const { values } = useFormikContext();

	const { deploy, stage, allowance, setForSale } = useCartridgeCreatorProvider();

	const handleDeploy = () => {
		if (stage != Stages.UNDEPLOYED) return;

		const formData = values as any;

		const metadataObject = {
			colors: formData.colors,
			description: formData.description,
			email: formData.email,
			gameUrl: formData.gameUrl,
			gamepaper: formData.gamepaper,
			media: formData.media,
			screenshots: formData.screenshots,
			socials: formData.socials,
			video: formData.video,
			genre: formData.tags,
			platforms: formData.platforms,
			name: formData.name,
		};
		console.log('Marketplace Fee: ', (values as any).marketplaceFee);

		deploy(
			formData.totalSupply,
			formData.name,
			formData.symbol,
			formData.transferFee,
			metadataObject as any,
			formData.cartridge,
			(formData.media as any).icon
		);
	};

	const handleAllowance = () => {
		if (stage != Stages.DEPLOYED) return;
		const formData = values as any;

		allowance(formData.storeSupply);
	};

	const handleSetForSale = () => {
		if (stage != Stages.IGO_ALLOWED) return;

		setForSale(
			'0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
			(values as any).price,
			(values as any).storeSupply,
			(values as any).marketplaceFee
		);
	};

	return (
		<TwoColumn>
			<LeftColumn>
				<FormSectionHeading label={t('form.steps.finalization.label')}>
					{t('form.steps.finalization.heading')}
				</FormSectionHeading>

				<FinalizationButtons
					handleAllowance={handleAllowance}
					stage={stage}
					handleDeploy={handleDeploy}
					handleSetForSale={handleSetForSale}
				/>
				<Box
					w="200px"
					overflow="scroll"
					display="none"
				>
					<pre>{JSON.stringify(values, null, 2)}</pre>;
				</Box>

				<FormSectionAddon>
					<Box></Box>
				</FormSectionAddon>
			</LeftColumn>
			<RightColumn>
				<Grid>
					<FinalizationProgress stage={stage} />
				</Grid>
			</RightColumn>
		</TwoColumn>
	);
};
